import { createActions } from 'redux-actions';

export default createActions({
    INIT_VISUAL: (section, value) => ({ section, value }),
    SET_VISUAL: (section, key, value) => ({ section, key, value }),
    UNSET_VISUAL: (section, key) => ({ section, key }),
});



// WEBPACK FOOTER //
// ./src/redux/actions/visualActions.js